export const PRESSING_DAMAGE_REQUEST = "PRESSING_DAMAGE_REQUEST";
export const PRESSING_DAMAGE_SUCCESS = "PRESSING_DAMAGE_SUCCESS";
export const PRESSING_DAMAGE_FAILED = "PRESSING_DAMAGE_FAILED";